$(function() {
  $("#toggle-mute").on("click", function() {
    var button = $(this);
    if (player.isMuted()) {
      var text = "Vypnout zvuk";
      player.unMute();
    } else {
      var text = "Zapnout zvuk";
      player.mute();
    }
    button.children("span").text(text);
  });
});
